/* eslint-disable global-require */
module.exports = ['ails.landingpage.m1', ...require('./Header/i18n'), ...require('./Sales/i18n'), ...require('./Lots/i18n'), ...require('./Agenda/i18n'), ...require('./Records/i18n'), ...require('./Consignment/i18n')];
